import { Api } from 'utils';

class PlanService {

	static admin = {
		get: async (params?: any) => Api.createResponse('admin/plans',params),
		create: async (params?: any) => Api.createResponse('admin/plans/create',params),
		update: async (params?: any) => Api.createResponse('admin/plans/update',params),
		createOrUpdate: async (params?: any) => Api.createResponse('admin/plans/create-or-update',params),
		getHistory: async (params?: any) => Api.createResponse('admin/plans/history',params),
		download: async (params?: any) => Api.createResponse('admin/plans/download',params),
		downloadPayment: async (params?: any) => Api.createResponse('admin/plans/download-payment',params),
		changeStatus: async (params?: any) => Api.createResponse('admin/plans/change-status',params),
		remove: async (params?: any) => Api.createResponse('admin/plans/remove',params),
		deleteTeleconsultationRate: async (params?: any) => Api.createResponse('admin/plans/teleconsultationrates-delete',params),
	}

	static doctor = {
		getHistory: async (params?: any) => Api.createResponse('doctor/plan/history',params),
		downloadPayment: async (params?: any) => Api.createResponse('doctor/plan/download-payment',params),
	}

	static clinic = {
		getHistory: async (params?: any) => Api.createResponse('clinic/plan/history',params),
		downloadPayment: async (params?: any) => Api.createResponse('clinic/plan/download-payment',params),
	}

	static affiliate = {
		payPlan: async (params?: any) => Api.createResponse('app/affiliate/plan/pay',params),
	}
}

export default PlanService;